export default (theme) => ({
  wrapper: {
    display: 'flex',
    lineHeight: '16px',
  },
  link: {
    cursor: 'pointer',
    color: theme.palette.secondary.main,
    textDecoration: 'underline',
  },
  errorText: {
    lineHeight: 1,
  },
});
